const initialState = () => ({
  selectedOption: {
    factTable: '',
    optionName: '',
    dateRange: {
      actual: '',
      previous: ''
    }
  },
  currentView: 'CardView',
  factTable: 'dw_last_week_comparative',
  selectedDimension: {
    card1: {
      store_dimensions: ['retail_name'],
      product_dimensions: []
    },
    card2: {
      store_dimensions: ['retail_name'],
      product_dimensions: []
    },
    card3: {
      store_dimensions: ['comuna'],
      product_dimensions: []
    },
    card4: {
      store_dimensions: ['store_type'],
      product_dimensions: []
    },
    card5: {
      store_dimensions: ['promoter_present'],
      product_dimensions: []
    }
  }
})

const state = initialState()

const getters = {
}

const mutations = {
  commit_accumulatedSalesView (state, currentView) {
    state.currentView = currentView
  },
  commit_accumulatedSalesFactTable (state, factTable) {
    state.factTable = factTable
  },
  commit_selectedDimension (state, arr) {
    state.selectedDimension[arr[1]] = arr[0]
  },
  commit_accumulatedSales_resetState (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/accumulatedSales.js